import React from "react";

export default function AppPreview() {
  const images = [
    "/app-screen/eduat10-app-view.gif",
  ];

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>

          {/* LOGO */}
          <div style={{ textAlign: "center", marginBottom: 20 }}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />
          </div>

          {/* TITLE */}
          <h1 style={titleStyle}>Explore EduAt10 App</h1>
          <p>
            See What You Get Inside <br />
            Before registration, explore the features and screens of our app
            to understand how EduAt10 helps students in learning and practice.
          </p>

          {/* 🎥 YOUTUBE VIDEO */}
          <div style={videoContainer}>
            <iframe
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/xRj4J21Fazk"
              title="Eduat10 Web Application How to Access"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              style={videoStyle}
            ></iframe>
          </div>

          {/* IMAGES */}
          <div style={imageContainer}>
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`preview-${index}`}
                style={imageStyle}
              />
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 30,
};

const cardStyle = {
  maxWidth: 1000,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 30,
};

const logoStyle = {
  width: 120,
};

const titleStyle = {
  fontSize: 26,
  fontWeight: "800",
  marginBottom: 10,
};

/* 🎥 VIDEO STYLE */
const videoContainer = {
  marginTop: 20,
  marginBottom: 30,
  display: "flex",
  justifyContent: "center",
};

const videoStyle = {
  width: "100%",
  maxWidth: 800,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
};

const imageContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 20,
};

const imageStyle = {
  width: "100%",
  maxWidth: 400,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
};